import { Assert } from '@previo/core'
// noinspection ES6PreferShortImport
import { PSpacePrimitive } from '../components/space/types'
import type { BreakpointSpaceOverride, SpacingOverrides } from '../types/PrevioDesignSystemOptions'

const primitiveVar = (primitive: PSpacePrimitive): string => `var(--${primitive})`

export const applySpacingOverrides = (spacing?: SpacingOverrides): void => {
  if (!spacing) {
    return
  }

  const root = document.documentElement

  for (const [key, override] of Object.entries(spacing)) {
    if (typeof override === 'string') {
      const value = primitiveVar(override)
      root.style.setProperty(`--space-${key}-mobile`, value)
      root.style.setProperty(`--space-${key}-laptop`, value)
      root.style.setProperty(`--space-${key}-desktop`, value)
      continue
    }

    Assert.isObject<BreakpointSpaceOverride>(override)

    if (override.mobile) {
      root.style.setProperty(`--space-${key}-mobile`, primitiveVar(override.mobile))
    }
    if (override.laptop) {
      root.style.setProperty(`--space-${key}-laptop`, primitiveVar(override.laptop))
    }
    if (override.desktop) {
      root.style.setProperty(`--space-${key}-desktop`, primitiveVar(override.desktop))
    }
  }
}
